export default {
  getPopularSearch: {
    event: { name: 'GetPopularSearch', state: 'APICall' },
    dependency: {
      name: 'API Gateway',
      event: 'GetPopularSearch',
      service: 'rll-gw-api',
    },
  },
  getItemsByCategory: {
    event: { name: 'Search', state: 'getItemsByCategory' },
    dependency: {
      name: 'API Gateway',
      event: 'getItemsByCategory',
      service: 'rll-gw-api',
    },
  },
}
